import { render, staticRenderFns } from "./LostReport.vue?vue&type=template&id=7b05d8f4&scoped=true"
import script from "./LostReport.vue?vue&type=script&lang=js"
export * from "./LostReport.vue?vue&type=script&lang=js"
import style0 from "./LostReport.vue?vue&type=style&index=0&id=7b05d8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b05d8f4",
  null
  
)

export default component.exports